import { http } from 'src/utils/http.util'
import { THRContact, THRSendMessengerRequest, THRSmsLog } from 'src/types/hr'

export const HRContactService = {
  getContacts: async (projectId: number): Promise<THRContact[]> =>
    http.get(`/projects/${projectId}/hr/contacts`).then((res) => res.data),

  createContact: async (
    projectId: number,
    data: Partial<
      Omit<
        THRContact,
        'id' | 'ProjectId' | 'deletedAt' | 'importedAt' | 'CommunicationChannelId' | 'isPhoneValid'
      >
    >,
  ): Promise<THRContact> => http.post(`/projects/${projectId}/hr/contacts`, data).then((res) => res.data),

  updateContact: async (
    projectId: number,
    id: number,
    data: Partial<
      Omit<
        THRContact,
        'id' | 'ProjectId' | 'deletedAt' | 'importedAt' | 'CommunicationChannelId' | 'isPhoneValid'
      >
    >,
  ): Promise<THRContact> =>
    http.put(`/projects/${projectId}/hr/contacts/${id}`, data).then((res) => res.data),

  deleteContact: async (projectId: number, id: number): Promise<void> =>
    http.delete(`/projects/${projectId}/hr/contacts/${id}`).then((res) => res.data),

  sendMessage: async (projectId: number, hrContactId: number, data: THRSendMessengerRequest): Promise<void> =>
    http.post(`/projects/${projectId}/hr/contacts/${hrContactId}/messenger`, data).then((res) => res.data),

  getContactSmsLogs: async (projectId: number, contactId: number): Promise<THRSmsLog[]> =>
    http.get(`/projects/${projectId}/hr/contacts/${contactId}/sms-logs`).then((res) => res.data),
}
